import React from 'react'
import SubHeader from '../../../layout/components/SubHeader'
import {toAbsoluteUrl} from '../../../helpers/AssetHelpers'
import ReminderCard from './tabcards/ReminderCard'

function ReminderSettings() {
  return (
    <>
       <SubHeader title="Clinic Reminders" description={"Clinic reminder related settings."}/> 
       <div className="row">
        <div className="col-3">
        <img src={toAbsoluteUrl('/media/illustrations/ecx/calendar_8r6s.svg')} className='img-fluid p-5' />
        </div>
        <div className="col-9">
           <ReminderCard />
        </div>
    </div>
    </>
  )
}

export default ReminderSettings